import { CSSProperties } from 'react';
import styled from 'styled-components';

import { EnergyPotential } from '~src/components/EnergyPotential';
import { useDisplayContext } from '~src/context/DisplayContext';

type Props = {
  setVisible?: (visible: boolean) => void;
  style?: CSSProperties;
};

const LoadingScreenOverlay = styled.div({
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'center',
  justifyContent: 'center',
  height: 'fit-content',
  padding: '1rem',
  borderRadius: '24px',
  zIndex: 1e5,
});

export const LoadingScreen = ({ style }: Props) => {
  const { isMobile, width: screenWidth, height: screenHeight } = useDisplayContext();

  const imageSize = isMobile ? { width: screenWidth * 0.65 } : { height: screenHeight * 0.35 };

  return (
    <LoadingScreenOverlay>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          margin: '0 2rem',
          ...style,
        }}
      >
        <EnergyPotential {...{ heatPump: true, solarPanel: true, chargingStation: true, ...imageSize }} />
      </div>
    </LoadingScreenOverlay>
  );
};
